import React from "react";
import { Link } from "react-router-dom";

// ⚠️ Placeholder content — replace with real legal text before launch.
const TermsOfUse: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto p-6 md:p-10">
      <Link to="/login" className="text-blue-500 text-sm hover:underline">
        ← Retour
      </Link>
      <h1 className="text-2xl font-bold mt-4 mb-6">
        Conditions Générales d'Utilisation
      </h1>
      <p className="text-sm text-gray-500 mb-6">
        Dernière mise à jour : [à compléter]
      </p>

      <div className="prose prose-sm max-w-none text-gray-700 space-y-4">
        <p>
          <em>
            Ce texte est un espace réservé. Le contenu juridique définitif des
            Conditions Générales d'Utilisation de RAJAPI-COP doit être fourni et
            validé avant la mise en production.
          </em>
        </p>
        <h2 className="text-lg font-semibold">1. Objet</h2>
        <p>
          Les présentes conditions régissent l'accès et l'utilisation de la
          plateforme RAJAPI-COP par ses utilisateurs.
        </p>
        <h2 className="text-lg font-semibold">2. Acceptation</h2>
        <p>
          En créant un compte, l'utilisateur reconnaît avoir pris connaissance
          des présentes conditions et les accepter sans réserve.
        </p>
        <h2 className="text-lg font-semibold">3. Compte utilisateur</h2>
        <p>
          L'utilisateur est responsable de la confidentialité de ses
          identifiants et de toute activité effectuée depuis son compte.
        </p>
      </div>
    </div>
  );
};

export default TermsOfUse;
